export const GET_RANKING_STARTED = 'GET_RANKING_STARTED'
export const GET_RANKING_SUCCESS = 'GET_RANKING_SUCCESS'
export const GET_RANKING_FAILURE = 'GET_RANKING_FAILURE'
